<template>
  <div>
    <MiniMap
      v-bind:level="level"
      v-bind:locale="locale"
      v-bind:type="type"
      v-bind:skill="$route.params.skill"
    />
    <Question
      v-for="(question, i) in questions"
      :key="question.uid"
      v-model="result[i]"
      :locale="locale"
      v-bind:question="question"
    />
  </div>
</template>

<script>
import Question from "./components/Question.vue";
import MiniMap from "./components/MiniMap.vue";
export default {
  name: "Level",
  props: {
    value: {
      type: Array
    },
    level: String,
    questions: Array,
    locale: String,
    type: String
  },
  components: {
    Question,
    MiniMap
  },
  computed: {
    result: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      }
    }
  }
};
</script>

<style></style>
